var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgProduct = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6448 3.95755C15.6448 3.94063 15.6448 3.94063 15.6448 3.92372C15.6278 3.88989 15.6278 3.85607 15.6109 3.82224V3.80533C15.594 3.77151 15.5602 3.73768 15.5433 3.72077L15.5264 3.70386C15.5095 3.68694 15.4756 3.67003 15.4587 3.65312L15.4418 3.63621H15.4249L15.408 3.61929L8.22013 0.0507378C8.08483 -0.0169126 7.91571 -0.0169126 7.76349 0.0507378L5.34499 1.25153L12.5667 4.95539L12.5836 4.9723C12.6005 4.9723 12.6005 4.98921 12.6174 4.98921C12.6343 5.00613 12.6343 5.02304 12.6512 5.03995C12.6512 5.05686 12.6512 5.05686 12.6512 5.07378V5.09069V9.01441C12.6512 9.08206 12.6174 9.1328 12.5667 9.16662L11.1122 9.92769C11.0276 9.97843 10.9261 9.9446 10.8754 9.86004C10.8585 9.84313 10.8585 9.8093 10.8585 9.77547V5.93632L3.55226 2.16481L3.53535 2.1479L0.609469 3.60238L0.592556 3.61929H0.575643L0.558731 3.63621C0.541818 3.65312 0.507993 3.67003 0.49108 3.68694L0.474168 3.70386C0.440343 3.73768 0.42343 3.77151 0.389605 3.80533V3.82224C0.372692 3.85607 0.35578 3.88989 0.35578 3.92372C0.35578 3.94063 0.35578 3.94063 0.35578 3.95755C0.35578 3.99137 0.338867 4.00828 0.338867 4.04211V4.05902V11.9403C0.338867 12.1263 0.440343 12.3124 0.626381 12.3969L7.74658 15.9486C7.84806 15.9993 7.96644 16.0162 8.08483 15.9824L8.11866 15.9655C8.15248 15.9655 8.16939 15.9486 8.20322 15.9317L15.3742 12.38C15.5433 12.2955 15.6617 12.1263 15.6617 11.9234V4.05902V4.04211C15.6448 4.00828 15.6448 3.99137 15.6448 3.95755Z",
    fill: "#8E8E8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProduct, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/product.1327edce.svg";
export { ForwardRef as ReactComponent };